export default __webpack_public_path__ + "static/media/pavlaka_20_0-18l.2402f388.jpg";